<template>
  <section
    class="headerrow py-16"
    :style="componentStyle"
    :id="sectionId"
  >
    <v-row>
      <v-col
        class="headercontent"
        align="center"
        cols="12"
      >
        <h1>{{title}}</h1>
        <p
          v-html="textWithInsertedValues"
          :class="plans.length ? 'mb-10' : ''"
        ></p>
      </v-col>
    </v-row>
    <div class="maincontent">
      <v-container>
        <v-row
          v-if="features && features.length && plans.length"
          justify="center"
          class="pb-6"
        >
          <template v-for="(plan, i) in plans">
            <!-- BASIC -->
            <div
              v-if="plan.Title.toLowerCase() === 'basic'"
              class="plan-card card-behind"
              :key="`basic-plan-${i}`"
            >
              <h2
                class="font-weight-medium pl-5"
                align="left"
              >{{plan.Title}}</h2>
              <p
                class="description primary--text pl-5 mb-0"
                v-if="planExtended(plan.EnumTypeId)"
                v-html=" planExtended(plan.EnumTypeId).description"
              ></p>
              <v-list align="left">
                <v-list-item
                  v-for="(feature, i) in featuresByPlanEnumTypeId(plan.EnumTypeId)"
                  :key="`basic-feature-${i}`"
                  :style="{color: feature.available? 'rgba(89,181,186,1)!important' : 'rgba(89,181,186,0.3)!important'}"
                >
                  <v-list-item-icon class="mr-4">
                    <v-icon :color="feature.available? 'rgba(89,181,186,1)' : 'rgba(89,181,186,0.3)'">mdi-check</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      class="list-item-multiple-lines"
                      v-html="feature.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div class="card-behind-footer">
                <p
                  class="disclaimer primary--text pl-5 mb-5"
                  v-if="planExtended(plan.EnumTypeId)"
                >
                  {{planExtended(plan.EnumTypeId).disclaimer}}
                </p>
                <p class="pl-5 primary--text">kr&nbsp;<span style="font-size: 40px;">0</span>,-</p>
                <v-btn
                  class="disabled-btn pl-5"
                  disabled
                  style="width: 256px;"
                >Aktivert</v-btn>
              </div>
            </div>
            <!-- OTHER PLANS -->
            <div
              v-else
              class="plan-card card-front"
              :key="`plan-${i}`"
            >
              <!-- <div class="demoting">
            <p>Spar kr 1500</p>
          </div> -->
              <h2 class="font-weight-medium">{{plan.Title}}</h2>
              <span
                class="description white--text pl-5"
                v-if="planExtended(plan.EnumTypeId)"
              >
                {{planExtended(plan.EnumTypeId).description}}
              </span>
              <v-list color="transparent">
                <v-list-item
                  v-for="(feature, i) in featuresByPlanEnumTypeId(plan.EnumTypeId)"
                  :key="`feature-${i}`"
                  :style="{color: feature.available? 'white!important' : 'rgba(255,255,255,0.3)!important'}"
                >
                  <v-list-item-icon class="mr-5">
                    <v-icon :color="feature.available? 'white' : 'rgba(255,255,255,0.3)'">mdi-check</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      class="list-item-multiple-lines"
                      v-html="feature.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div class="card-front-footer">
                <div
                  class="pl-5"
                  style="color:white; text-align:left"
                >kr&nbsp;<span style="font-size:41px;color:white">{{plan.Price}}</span>/mnd pr avdeling</div>
                <v-btn
                  align="center"
                  style="width: 256px;background-color:#FB6863;color:white"
                  depressed
                  @click="onBtnClick()"
                ><template v-if="plan.AllowTrialPeriod">Prøv gratis i {{plan.TrialPeriod}} måneder</template><template v-else>Kjøp nå</template></v-btn>
              </div>
            </div>

          </template>

        </v-row>
      </v-container>
    </div>

    <v-row
      v-if="features && features.length && plans.length"
      class="bg--primary"
    ></v-row>
  </section>
</template>
<script>
import promotionPageMixin from '../mixins/promotion-page'
import { orderBy } from 'lodash'
import { getInternalRoute } from '../utils/routing'

const trialPeriodMonths = /\{trialPeriodMonths\}/gi
const numberInWriting = {
  1: 'en',
  2: 'to',
  3: 'tre',
  4: 'fire',
  5: 'fem',
  6: 'seks',
  7: 'sju',
  8: 'åtte',
  9: 'ni',
  10: 'ti',
  11: 'elleve',
  12: 'tolv'
}
export default {
  mixins: [promotionPageMixin],
  props: {
    title: {
      type: String,
      default: 'Priser'
    },
    text: {
      type: String,
      default: ''
    },
    features: {
      type: Array,
      default: () => []
    },
    plansExtended: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    plans () {
      return orderBy(this.subscriptionPlans.concat(), ['Price', 'Title'])
    },
    textWithInsertedValues () {
      let plan = this.plans.find(p => p.AllowTrialPeriod && p.TrialPeriod > 0)
      let trialPeriod = plan ? this.numberInWriting(plan.TrialPeriod) : ''
      return this.text.replace(trialPeriodMonths, trialPeriod)
    }
  },
  methods: {
    featuresByPlanEnumTypeId (enumTypeId) {
      return orderBy(this.features.filter(f => parseInt(f.subscriptionPlanEnumTypeId) === enumTypeId).concat(), ['available'], ['desc'])
    },
    onBtnClick () {
      let url = this.btnUrl ? this.btnUrl : this.ctaUrl
      let route = getInternalRoute(url)
      if (route) {
        this.$router.push(route)
      } else if (url) {
        window.location.href = url
      }
    },
    numberInWriting (n) {
      return numberInWriting[n] || n
    },
    planExtended (planId) {
      return this.plansExtended.find(x => x.type == planId) || {}
    }
  }
}
</script>
<style scoped>
.disclaimer {
  font-size: 12px;
  font-style: italic;
}
.description {
  font-size: 18px;
  line-height: 21px;
  font-weight: 500;
  letter-spacing: 0;
}
.list-item-multiple-lines {
  overflow: unset !important;
  text-overflow: unset !important;
  white-space: unset !important;
}
.headerrow {
  background-color: rgba(223, 242, 243, 1);
}

.headercontent {
  margin-bottom: 20px;
}

.headercontent h1 {
  font-family: "Niveau Grotesk";
  font-size: 42px;
}

.headercontent p {
  width: 746px;
  font-family: "Niveau Grotesk";
  font-size: 20px;
  text-align: center;
}

.maincontent {
  background-color: #ffffff;
}

.plan-card {
  margin-right: 12px;
  margin-left: 12px;
}
.card-front {
  display: block;
  width: 295px;
  border-radius: 34px;
  margin-top: -40px;
  background-color: #69adb1;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
  padding: 10px;
}

.card-behind {
  display: block;
  width: 295px;
}

.card-behind h2 {
  margin-top: 23px;
  color: rgba(89, 181, 186, 1);
  font-family: "Niveau Grotesk";
  font-size: 36px;
}

.card-front h2 {
  margin-top: -10px;
  padding-top: 22px;
  padding-left: 20px;
  color: white;
  font-family: "Niveau Grotesk";
  font-size: 36px;
}

.card-front-footer {
  text-align: center;
}

.demoting {
  height: 231px;
  width: 35px;
  float: right;
  justify-content: center;
  align-items: center;
  margin-top: -45px;
  transform: scaleX(1) rotate(-45deg);
  background-color: #ffffff;
}

.demoting::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-top: 30px solid rgba(223, 242, 243, 1);
  border-left: 30px solid white;
}

.demoting p {
  height: 21px;
  width: 97px;
  margin: auto;
  transform: rotate(90deg);
  color: rgba(125, 197, 201, 1);
  font-family: "Niveau Grotesk";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 90px;
  margin-top: 63px;
}

.card-front .v-list-item__title {
  font-size: 16px;
}

@media only screen and (max-width: 600px) {
  .headerrow p {
    width: 100%;
  }
  .card-front {
    margin-top: 40px;
  }
  .demoting p {
    line-height: 5;
    width: 100px;
  }
}

/* Vuetify overrides */
.v-btn {
  text-transform: unset !important;
  font-size: 16px;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).disabled-btn {
  color: #fb6863 !important;
  background-color: rgba(251, 104, 99, 0.15) !important;
}
</style>
